class UrlParameter {
    public constructor(private readonly key: string) {}

    public tryReadFromUrl(): string | null {
        if (typeof URLSearchParams === "undefined") {
            console.debug(`Browser does not support URLSearchParams.`);
            return null;
        }

        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(this.key);
    }

    public storeInUrl(value: string): void {
        if (typeof URLSearchParams === "undefined") {
            console.debug(`Browser does not support URLSearchParams.`);
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set(this.key, value);

        const newUrl = new URL(window.location.href);
        newUrl.search = urlParams.toString();
        window.history.replaceState("", "", newUrl);
    }
}

export {
    UrlParameter,
};
